module.exports = __webpack_public_path__ + "static/media/three_lady_eye_blink_01.5df46082.gif";